<template>
  <div class="container-fluid">
    <b-button variant="secondary" size="sm" @click="openLinkRequirementsDialog">
        <icon name="pencil"></icon>
        Edit
      </b-button>
    <table class="rm-table right-panel-requirements-table" v-if="requirements.length > 0">
      <thead>
      <th>ID</th>
      <th>Name</th>
      </thead>
      <tbody>
      <tr v-for="requirement in requirements">
        <td> <a :href="getNewTabLink(requirement)" target="_blank">{{requirement.prefix}}{{requirement.display_id ? requirement.display_id : requirement.requirement_id}}</a></td>
        <td>{{requirement.name}}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import utilsMixin from '@/mixins/utils'
  export default {
    data () {
      return {
        baseUrl: null,
        issueId: this.$route.query.issueId,
        projectId: this.$route.query.projectId,
        requirements: []
      }
    },
    created () {
      this.getBaseUrl()
      this.getLinkedRequirements()
    },
    mixins: [utilsMixin],
    methods: {
      getLinkedRequirements () {
        this.$http.get(
          `/api/requirement?atlassian_project_id=${this.projectId}&atlassian_project_id=0&atlassian_issue_id=${this.issueId}`,
        ).then(response => {
          this.requirements = response.data.requirements
        }, response => {
          console.log('error')
        })
      },
      getBaseUrl () {
        window.AP.getLocation(location => {
          const url = new URL(location)
          this.baseUrl = url.origin
        })
      },
      getNewTabLink (requirement) {
        return `${this.baseUrl}/plugins/servlet/ac/${process.env.ADDON_DESCRIPTOR_KEY}/rmcloud?ac.projectId=${this.projectId}&ac.requirementId=${requirement.requirement_id}`
      },
      openLinkRequirementsDialog () {
        window.AP.dialog.create({
          key: 'link-requirements-dialog',
          width: '80%',
          height: '60%',
          chrome: true,
          header: 'Update linked requirements',
          customData: {
            issueId: this.issueId,
            projectId: this.projectId
          }
        }).on('close', this.getLinkedRequirements)
      }
    }
  }
</script>

<style>
  .right-panel-requirements-table {
    font-size: 13px;
  }
</style>



// WEBPACK FOOTER //
// IssueViewRequirementsRightPanelView.vue?28fe7577